import React from 'react';

interface Props {
  url: string;
}

const TestimonialAvatar = ({url}: Props) => (
  <div className="about-testimonial-avatar-container">
    <img className="about-testimonial-avatar-picture" src={url} alt="user avatar" />
  </div>
);

export default TestimonialAvatar;
